import { useLayoutEffect, useState } from "react";
import { debounce } from "lodash";

export interface WindowMeasure {
  height: number;
  isResizing: boolean;
  width: number;
}

const useWindowMeasure = (): WindowMeasure => {
  const [windowMeasure, setWindowMeasure] = useState<WindowMeasure>({
    width: 0,
    height: 0,
    isResizing: true,
  });

  useLayoutEffect(() => {
    const updateMeasure = (): void => {
      setWindowMeasure({
        width: window.innerWidth,
        height: window.innerHeight,
        isResizing: false,
      });
    };

    updateMeasure();

    window.addEventListener("resize", () => {
      // na mobile chrome sie resizuje w height podczas scrollowania
      // dlatego dodalem sprawdzenie czy zmienil sie width bez ktorego nie odpali sie update
      // nie jest to idealne, ale wlasciwie zachowanie na desktopie w cale nie jest jakies uciazliwe
      // https://stackoverflow.com/questions/17328742/mobile-chrome-fires-resize-event-on-scroll
      setWindowMeasure((prevMeasure) => {
        if (
          prevMeasure.width !== window.innerWidth
          // prevMeasure.height !== window.innerHeight
        ) {
          debounce(updateMeasure, 600)();

          return {
            width: window.innerWidth,
            height: window.innerHeight,
            isResizing: true,
          };
        }

        return prevMeasure;
      });
    });

    // TODO: zapytaj Dawida, windowWidth zawiera w sobie szerokosc razem ze scrollbarem

    return () => window.removeEventListener("resize", updateMeasure);
  }, []);

  return windowMeasure;
};

export default useWindowMeasure;
